import { useEffect, useRef, useState } from 'react';

import { useBoundStore } from 'app/store';
import { useBlockScroll } from 'shared/model/useBlockScroll';

import { SignModal } from './SignModal';

export const SignModalContainer = () => {
  const [currentSignData, setCurrentSignData] = useState({
    signFile: null,
    errorText: null,
  });

  const canvasRef = useRef(null);
  const { ptNm } = useBoundStore((state) => state['hsptlzForm'].serviceParams);
  const signCanvasCtx = useBoundStore((state) => state['hsptlzForm'].signCanvasCtx);
  const setSignCanvasPlaceHolder = useBoundStore((state) => state['hsptlzForm'].setSignCanvasPlaceHolder);

  const reset = () => {
    if (signCanvasCtx) signCanvasCtx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    setCurrentSignData({ signFile: null, errorText: null });
    setSignCanvasPlaceHolder(true);
  };

  useEffect(() => {
    reset();
  }, []);

  useBlockScroll();

  return (
    <SignModal>
      <SignModal.Title ptNm={ptNm} />
      <SignModal.SignBox
        currentSignData={currentSignData}
        setCurrentSignData={setCurrentSignData}
        reset={reset}
        ref={canvasRef}
      />
      <SignModal.Guide />
      <SignModal.Button reset={reset} currentSignData={currentSignData} />
    </SignModal>
  );
};
